import List from "../singleton/list";

export default {

    get: List.get.bind(List),

    rename: List.rename.bind(List),

    getByRelation: List.getByRelation.bind(List),

    toggleUseGlobal: List.toggleUseGlobal.bind(List),

    setViewsOrder: List.setViewsOrder.bind(List)

}